export default __webpack_public_path__ + "static/media/30-day-money.2f633051.jpg";